import { IModel } from '../@types/models/model';
import coreFields from './helpers/coreFields';

const ChemElement: IModel = {
  title: 'Chemical elements',
  apiPath: 'chem/elements',
  forms: {
    default: {
      fields: ['id'],
    },
  },
  listViews: {
    default: {
      fields: ['id', 'symbol', 'title', 'composition_mg_kg', 'composition_mg_kg_lower', 'composition_mg_kg_higher'],
      hidden: ['id', 'composition_mg_kg_lower', 'composition_mg_kg_higher']
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'Atomic number',
      source: 'atomic_number',
      ttoken: 'chem:elements.atomic_number',
      type: 'wholenum',
      filter: true,
    },
    {
      title: 'Title',
      source: 'title',
      ttoken: 'chem:elements.title',
      type: 'text',
      filter: true,
    },
    {
      title: 'Symbol',
      source: 'symbol',
      ttoken: 'chem:elements.symbol',
      type: 'text',
      filter: true,
    },
    {
      title: 'Is REE',
      source: 'is_ree',
      ttoken: 'chem:elements.is_ree',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
    },
    {
      title: 'category',
      source: 'category',
      ttoken: 'chem:elements.category',
      type: 'text',
      filter: true,
    },
    {
      title: 'Atomic mass',
      source: 'atomic_mass',
      ttoken: 'chem:elements.atomic_mass',
      type: 'numeric',
      filter: true,
    },
    {
      title: 'Composition (mg/kg)',
      source: 'composition_mg_kg',
      ttoken: 'chem:elements.composition_mg_kg',
      type: 'text',
      filter: true,
    },
    {
      title: 'Composition (mg/kg) - Lower bound',
      source: 'composition_mg_kg_lower',
      ttoken: 'chem:elements.composition_mg_kg_lower',
      type: 'numeric',
      filter: true,
    },
    {
      title: 'Composition (mg/kg) - Higher bound',
      source: 'composition_mg_kg_higher',
      ttoken: 'chem:elements.composition_mg_kg_higher',
      type: 'numeric',
      filter: true,
    }
  ],
};

export default ChemElement;
